import request from "@/request/request-utils";

export default {
  // 店铺字典
  shop: () => request.getAction("/api/Seller/GetTaoBaoShopView"),
  // 店铺字典
  unishop: () => request.getAction("/api/UniversalSeller/GetShopOptions"),
  // 商品字典
  product: (params) =>
    request.getAction("/api/Seller/GetTaoBaoProductView", params),
  // 商品字典
  uniproduct: (params) =>
    request.getAction("/api/UniversalSeller/GetProductOptions", params),
  // 商品类别字典
  uniproductCategorie: (params) =>
    request.getAction(
      "/api/UniversalSeller/GetProductCategorieOptions",
      params
    ),
  // 字典
  baseData: () => request.getAction("/api/Seller/GetBaseData"),
};
